import dayjs from 'dayjs';
import map from 'lodash/map';

import { paginationModel } from '@project/models';
import { MagazineListApi, MagazineListItemApi, MagazineSubscriptionApi } from '@project/services';
import { MagazineListItemType, MagazineListType, MagazineSubscriptionType } from './types';

export const MagazineListItemModel = (data?: MagazineListItemApi): MagazineListItemType => ({
  id: data?.id ?? -1,
  name: data?.name ?? '',
  datePublished: data?.date_published ? dayjs(data.date_published).format('DD MMM YYYY') : '',
  paid: data?.paid ?? false,
  isLocked: data?.is_locked ?? false,
  content: data?.content ?? null,
  createdAt: data?.created_at ? dayjs(data.created_at).format('DD MMM YYYY') : '',
});

export const MagazineListModel = (data?: MagazineListApi): MagazineListType => ({
  magazines: map(data?.magazines ?? [], (magazine) => MagazineListItemModel(magazine)),
  meta: paginationModel(data?.meta),
});

export const MagazineSubscriptionModel = (
  data?: {
    subscription?: null;
  } & Partial<MagazineSubscriptionApi>,
): MagazineSubscriptionType => {
  if (!data || !data.id) return null;

  return {
    id: data.id,
    name: data.name ?? 'Magazine Subscription',
    amount: data.amount ?? 0,
    currency: data.currency ?? 'USD',
    status: data.status ?? '',
    createdAt: data.created_at ? dayjs(data.created_at).format('DD MMM YYYY') : '',
  };
};
